const dashboards = [
  {
    valor:"Otro",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10pormesdelperiodo2000a2010sinembarazos/Dashboard1"
    },
  {
    valor:"Embarazo, parto y puerperio",
    
    url:"https://public.tableau.com/views/NavegacindeServiciosdeSaludenbasealCIE-10pormesdelperiodo2000a2010embarazos/Dashboard1"
  }

  
];

export default dashboards;
